var React = require('react');

function BarChart (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"12","y1":"20","x2":"12","y2":"10","key":0}),React.createElement("line",{"x1":"18","y1":"20","x2":"18","y2":"4","key":1}),React.createElement("line",{"x1":"6","y1":"20","x2":"6","y2":"16","key":2})]);
}

BarChart.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-bar-chart"};

module.exports = BarChart;

BarChart.default = BarChart;
